import QuantitySelector from "@/components/ui/QuantitySelector";

interface ProductQuantityProps {
  quantity: number;
  maxQuantity: number | null;
  handleQuantityChange: (value: number) => void;
}

const ProductQuantity = ({ quantity, maxQuantity, handleQuantityChange }: ProductQuantityProps) => {
  return (
    <div className="flex items-center gap-4">
      <QuantitySelector
        quantity={quantity}
        size="lg"
        handleQuantityChange={(value) => handleQuantityChange(value)}
      />
      {maxQuantity && maxQuantity <= 2 && (
        <div className="brand-text-sm text-neutral">剩餘 {maxQuantity} 件</div>
      )}
    </div>
  );
};

export default ProductQuantity;
